import React from "react";
import "./CurrentSubscription.scss";
import { FileText, Users, Calendar, DollarSign, Clock } from "lucide-react";

const CurrentSubscription = ({ subscription, onRenew, onUpgrade }) => {
    // If no subscription or subscriptionPlan, show fallback
    if (!subscription || !subscription.subscriptionPlan) {
        return (
            <div className="current-subscription-container">
                <div className="subscription-header">
                    <h2>Subscription</h2>
                </div>
                <div className="subscription-details">
                    <div className="detail-card">
                        <div className="icon-wrapper">
                            <FileText size={24} />
                        </div>
                        <div className="detail-content">
                            <span>No Active Subscription</span>
                            <p>Please subscribe to a plan.</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Safe destructuring
    const { subscriptionPlan, expiryDate, price } = subscription;
    const { _id: planId, title, benefits, durationType } = subscriptionPlan;

    // Format the expiry date
    const expiry = new Date(expiryDate);
    const formattedExpiryDate = expiry.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
    });

    // Check if expired
    const isExpired = expiry < new Date();

    // Extract dynamic values from benefits
    const monthlyBookings =
        benefits?.find((benefit) => benefit.toLowerCase().includes("monthly bookings"))?.match(/\d+/)?.[0] ||
        "N/A";
    const serviceListings =
        benefits?.find((benefit) => benefit.toLowerCase().includes("service listings"))?.match(/\d+/)?.[0] ||
        "N/A";

    return (
        <div className="current-subscription-container">
            <div className="subscription-header">
                <h2>Subscription</h2>
                <div className="header-buttons">
                    {isExpired && (
                        <button className="change-plan-btn" onClick={() => onRenew(planId)}>
                            Renew
                        </button>
                    )}
                </div>
            </div>

            <div className="subscription-details">
                {/* Show title card only if title exists */}
                {title && (
                    <div className="detail-card">
                        <div className="icon-wrapper">
                            <FileText size={24} />
                        </div>
                        <div className="detail-content">
                            <span>{title}</span>
                            <p>Subscription</p>
                        </div>
                    </div>
                )}

                {/* Show Users card only if monthlyBookings has a valid value */}
                {monthlyBookings && monthlyBookings !== "N/A" && (
                    <div className="detail-card">
                        <div className="icon-wrapper">
                            <Users size={24} />
                        </div>
                        <div className="detail-content">
                            <span>{monthlyBookings}</span>
                            <p>Users</p>
                        </div>
                    </div>
                )}

                {/* Show Orders Limit card only if serviceListings has a valid value */}
                {serviceListings && serviceListings !== "N/A" && (
                    <div className="detail-card">
                        <div className="icon-wrapper">
                            <Calendar size={24} />
                        </div>
                        <div className="detail-content">
                            <span>{serviceListings}</span>
                            <p>Monthly Orders Limit</p>
                        </div>
                    </div>
                )}

                {/* Always show Plan Cost */}
                <div className="detail-card">
                    <div className="icon-wrapper">
                        <DollarSign size={24} />
                    </div>
                    <div className="detail-content">
                        <span>
                            KWD {price ? price.toFixed(2) : "0.00"}/{durationType === "monthly" ? "mo" : "yr"}
                        </span>
                        <p>Plan Cost</p>
                    </div>
                </div>

                {/* Always show Renewal Date */}
                <div className="detail-card">
                    <div className="icon-wrapper">
                        <Clock size={24} />
                    </div>
                    <div className="detail-content">
                        <span>{formattedExpiryDate}</span>
                        <p>Renewal Date</p>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default CurrentSubscription;